import React, { useEffect } from "react";
import "./financing.css";



/* Reveal on scroll */
function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  
}

const subject = "COSMETINK® Financing Options";

const body = [
  "Hi COSMETINK Team,",
  "",
  "I’m interested in financing options for:",
  "- Program: (Full Nano Brows / Nano Combo Brows / Ombré Brows / Lip Blush / Combo)",
  "- Desired start month:",
  "- Budget comfort (monthly or split):",
  "- Full name + phone:",
  "",
  "Please let me know next steps.",
  "",
  "Thank you!"
].join("\n");

const MAILTO = `mailto:cosmetinkbeauty@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;


export default function Financing() {
  useReveal();
useEffect(() => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}, []);

  return (
    <main className="fin-page">
      {/* ===== HERO (kept cinematic, copy simplified) ===== */}
      <section className="fin-hero">
        <video
          className="fin-hero-video"
          src="https://cosacademyvideos.s3.us-east-2.amazonaws.com/IMG_0936.mp4"
          autoPlay
          muted
          loop
          playsInline
        />
        <div className="fin-veil" aria-hidden />

        <div className="fin-hero-inner reveal">
          <h1 className="fin-hero-title">
            <span className="grad-ink">Financing, Simplified</span>
          </h1>
          <p className="fin-hero-tag">
            We offer flexible ways to start now and pay over time. For details, email us today.
          </p>

          <div className="fin-hero-cta">
            <a className="btn btn-primary" href={MAILTO}>
              Email Us for Options
            </a>

          </div>
        </div>
      </section>

      {/* ===== SIGNAL CARDS (no specifics) ===== */}
     

      {/* ===== KPI STRIP (kept aspirational) ===== */}


      {/* ===== HOW IT WORKS (generic) ===== */}
      <section className="fin-steps">
        <div className="container">
          <h3 className="fin-title reveal">How it works</h3>
          <ol className="steps reveal">
            <li>
              <span className="step-badge grad-ink">1</span>
              Email us your program + timeline.
            </li>
            <li>
              <span className="step-badge grad-ink">2</span>
              Get your individualized financing paths.
            </li>
            <li>
              <span className="step-badge grad-ink">3</span>
              Pick what fits; we reserve your seat.
            </li>
            <li>
              <span className="step-badge grad-ink">4</span>
              Train now—pay over time.
            </li>
          </ol>

          <div className="steps-cta reveal">
            <a className="btn btn-primary" href={MAILTO}>
              Email for Options
            </a>

          </div>
        </div>
      </section>

      {/* ===== FAQ (kept generic; no providers/terms) ===== */}
      <section className="fin-faq">
        <div className="container">
          <h3 className="fin-title reveal">Frequently asked</h3>


          <details className="faq-item reveal">
            <summary>How fast can I get financing details?</summary>
            <p>
              Same day in most cases. Email us and we’ll reply with your tailored paths and next steps.
            </p>
          </details>

          <details className="faq-item reveal">
            <summary>Can bundle discounts still apply?</summary>
            <p>Yes. We’ll outline the most advantageous route if you’re combining programs.</p>
          </details>

          <details className="faq-item reveal">
            <summary>Which classes are eligible?</summary>
            <p>All Fundamentals: Full Nano Brows, Nano Combo Brows, Ombré Brows, and Lip Blush (including combos).</p>
          </details>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="fin-final">
        <div className="container reveal">
          <h3 className="fin-final-title">
            Your next chapter starts now. <span className="grad-ink">We’ll guide the rest.</span>
          </h3>
          <p className="fin-final-copy">
            Write us with your program + timeline and we’ll send your private options.
          </p>
          <div className="fin-final-actions">
            <a className="btn btn-primary" href={MAILTO}>
              Email COSMETINK®
            </a>
 
          </div>
        </div>
      </section>
    </main>
  );
}
